import React, { useState } from 'react'
import { Button, Col, Divider, Popconfirm, Row, Table } from 'antd'
import { ButtonEx } from '../../../styles/button.style'
import WrappedBrandMaterialForm from './BrandMaterialForm'
import { useDispatch, useSelector } from 'react-redux'
import { deleteBrandMaterial, saveBrandMaterial } from '../../../modules/brand'

const BrandMaterial = ({ brand, onCancel }) => {
  const dispatch = useDispatch()
  const [visible, setVisible] = useState(false)

  const { materials } = useSelector(
    (state) => ({
      materials: state.material.materials
    }),
    []
  )

  const columns = [
    {
      title: 'รูป',
      dataIndex: 'image',
      key: 'image',
      render: (text, record) => <img src={text} alt="" width={64} height={64} />
    },
    {
      title: 'Material',
      key: 'name',
      dataIndex: 'name'
    },
    {
      title: 'หมวด',
      key: 'category',
      dataIndex: 'category',
      render: (text) => <span>{text.name}</span>
    },
    {
      title: 'Action',
      key: 'action',
      render: (text, record) => (
        <span>
          <Divider type="vertical" />
          <Popconfirm
            title="Sure to delete?"
            onConfirm={() => onDelete(record.id)}>
            <Button type="danger" size="small" shape="circle" icon="delete" />
          </Popconfirm>
        </span>
      )
    }
  ]

  const onClick = (e) => {
    e.preventDefault()
    setVisible(true)
  }

  const onCloseModal = () => {
    setVisible(false)
  }

  const onOk = async (materialIds) => {
    const data = {
      brandId: brand.id,
      materialIds: materialIds
    }

    await dispatch(saveBrandMaterial(data))
    await setVisible(false)
    await onCancel()
  }

  const onDelete = async (materialId) => {
    const data = {
      brandId: brand.id,
      materialId: materialId
    }
    await dispatch(deleteBrandMaterial(data))
    await onCancel()
  }

  const HeaderTable = () => {
    return (
      <Row type="flex">
        <Col span={12}>
          <span>Material List</span>
        </Col>
        <Col span={12}>
          <Row type="flex" justify="end">
            <ButtonEx
              color="#6ebf4b"
              type="primary"
              onClick={(e) => onClick(e)}>
              เพิ่มวัสดุ
            </ButtonEx>
          </Row>
        </Col>
      </Row>
    )
  }

  return (
    <div>
      <Table
        title={HeaderTable}
        bordered
        dataSource={brand.materialList}
        columns={columns}
        // pagination={{
        //   current: barcodeProductObj.pageable.pageNumber + 1,
        //   pageSize: barcodeProductObj.size,
        //   pageSizeOptions: ['10', '20', '50', '100'],
        //   showSizeChanger: true,
        //   onShowSizeChange: onShowSizeChange,
        //   onChange: onChange,
        //   total: barcodeProductObj.totalElements
        // }}
      />
      <WrappedBrandMaterialForm
        materials={materials}
        myMaterials={brand.materialList}
        visible={visible}
        onOk={onOk}
        onCancel={onCloseModal}
      />
    </div>
  )
}

export default BrandMaterial



// WEBPACK FOOTER //
// ./src/pages/Brand/BrandMaterial/index.js